import {Component, Inject, OnInit} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {BannerService} from '../../../banner/banner.service';
import gql from 'graphql-tag';
import {Mutation, PoItem, Query as WorkflowQuery} from '../../../types-workflow';
import {GET_PROCESS} from '../../../queries-repository';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';

import {DoButtonComponent} from '../../do-button/do-button.component';
import {MessageFieldComponent} from '../../do-button/message-field.component';
import {ProcessService} from '../../../services/process.service';
import {map, switchMap, tap} from 'rxjs/operators';
import {timer} from 'rxjs';

@Component({
  selector: 'app-finalize-po-dialog',
  templateUrl: './finalize-po-dialog.component.html',
  styleUrls: ['./finalize-po-dialog.component.scss'],
  imports: [
    RouterModule,
    FormsModule,
    DoButtonComponent,
    MessageFieldComponent
]
})
export class FinalizePoDialogComponent implements OnInit {
  poItemsInitial: PoItem[];
  poItems: PoItem[];
  publicationMode = 'unpublished';
  publishing = false;

  constructor(public dialogRef: DialogRef,
              private apollo: Apollo,
              private banner: BannerService,
              private processService: ProcessService,
              @Inject(DIALOG_DATA) public data: { po_name: string }) {
  }

  publicationChanged() {
    switch (this.publicationMode) {
      case 'unpublished':
        this.poItems = this.poItemsInitial.filter(poitem => poitem.publish_process?.state !== 'SUCCESS')
        break;
      case 'all':
        this.poItems = this.poItemsInitial.slice();
        break;
      case 'poonly':
        this.poItems = []
    }
  }

  isSelected(poitem: PoItem): boolean {
    return this.poItems?.some(item => item.po_item_id === poitem.po_item_id) ?? false;
  }

  toggle(poitem: PoItem) {
    this.publicationMode = 'selected';
    if (this.isSelected(poitem)) {
      this.poItems = this.poItems.filter(item => item.po_item_id !== poitem.po_item_id);
    } else {
      this.poItems = [...this.poItems, poitem];
    }
  }

  ngOnInit(): void {
    const query = gql`
      query GetPoItemPublishStatus($po_name: String!) {
        list_POs(input: { filter: { po_name: { eq: $po_name}}} ){
          pos {
            id
            po_name
            poitems {
              id
              po_item_id
              publish_process {
                id
                state
                start_date
                end_date
              }
              workflow_process {
                id
                state
                start_date
                end_date
              }
              vtk_template
              po_destination
              checkpoint_content_uploaded
              checkpoint_content_complete
              checkpoint_encodes_done
            }
          }
        }
      }
    `
    this.apollo.use('workflow').query<WorkflowQuery>({
      query: query,
      variables: {
        'po_name': this.data.po_name
      }
    }).subscribe(res => {
        if (!res.data?.list_POs?.pos?.[0]) return;
        this.poItemsInitial = res.data.list_POs.pos[0].poitems.slice()
          .filter(item => item.checkpoint_encodes_done)
          .filter(item => !(item.po_destination === null || item.po_destination === undefined || item.po_destination === 'manual_distribution'));

        this.publicationChanged();
      }
    )
  }

  publish(button: DoButtonComponent) {

    this.apollo.use('workflow').mutate<Mutation>({
      mutation: gql`
        mutation finalize_po($po_name: String!, $publish_po_item_ids: [String!]!)  {
          publish(input: { po_name: $po_name, skip_finalize: false, publish_po_item_ids: $publish_po_item_ids}) {
            id
            state
            message
            input
          }
        }
      `,
      variables: {
        po_name: this.data.po_name,
        publish_po_item_ids: this.poItems.map(v => v.po_item_id)
      }

    }).pipe(
      tap(res => button.info('Finalizing ' + this.data.po_name + '...', {duration: -1})),
      switchMap(res => this.processService.observeProcess(res.data.publish))
    ).subscribe({
        next: e => {
          if (e.state === 'SUCCESS') {
            button.done(e.message)
            timer(1000).subscribe(() => this.dialogRef.close())

          }
          if (e.state === 'FAILED') {
            this.banner.open('Finalization of ' + this.data.po_name + ' failed.', ['Close']);
            this.dialogRef.close()
          }
        },
        error: err => {
          this.banner.open(err, ['Close']);
        }
    })
  }
}
